import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Modal,
  Radio,
  RadioGroup,
} from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useEffect, useRef, useState } from "react";
import { RiFileExcel2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";
import {
  isAdmin,
  isPartnerOrAssistant,
  isTeacher,
} from "../../functions/checkrole";
import { getPrintCertificateFilter } from "../../functions/getData";
import Loader from "../general/Loader";
import LoadingBackdrop from "../general/LoadingBackdrop";
import NunitoText from "../general/NunitoText";
import ReusableButton from "../general/ReusableButton";

const extractFilterList = (data) =>
  Array.isArray(data)
    ? data
    : data?.data ?? data?.results ?? data?.items ?? [];

const mapFilterOptions = (data) =>
  extractFilterList(data).map((item) => ({
    label: item.label ?? item.filter_name ?? item.name,
    value: item.value ?? item.filter_id ?? item.id,
  }));

export default function NewCertificateModal({
  approveFunction,
  cancelApprove,
}) {
  const user = useSelector((state) => state.user);

  const [mode, setMode] = useState("no_background_template");
  const [country, setCountry] = useState("");
  const [organization, setOrganization] = useState("");
  // const [template, setTemplate] = useState("");
  const [province, setProvince] = useState([]);
  const [competition, setCompetition] = useState("");
  const [school, setSchool] = useState([]);
  const [grade, setGrade] = useState([]);
  const [indexNumber, setIndexNumber] = useState([]);
  const [studentName, setStudentName] = useState([]);
  const [awards, setAwards] = useState([]);
  const [show, setShow] = useState("");
  const [selectedSortingOptions, setSelectedSortingOptions] = useState([]);
  const [printWithStats, setPrintWithStats] = useState(true);
  const [certificateType, setCertificateType] = useState(null);
  const [certificateTypeOptions, setCertificateTypeOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingCompetitionOptions, setLoadingCompetitionOptions] =
    useState(false);
  const [loadingCountryOptions, setLoadingCountryOptions] = useState(false);
  const [loadingOrganizationOptions, setLoadingOrganizationOptions] =
    useState(false);
  const [loadingProvinceOptions, setLoadingProvinceOptions] = useState(false);
  const [loadingSchoolOptions, setLoadingSchoolOptions] = useState(false);
  const [loadingGradeOptions, setLoadingGradeOptions] = useState(false);
  const [loadingAwardsOptions, setLoadingAwardsOptions] = useState(false);
  const [loadingShowOptions, setLoadingShowOptions] = useState(false);
  const [loadingIndexNumberOptions, setLoadingIndexNumberOptions] =
    useState(false);
  const [loadingStudentNameOptions, setLoadingStudentNameOptions] =
    useState(false);
  const [loadingSortingOptions, setLoadingSortingOptions] = useState(false);
  const [modeOptions, setModeOptions] = useState([]);
  const [competitionOptions, setCompetitionOptions] = useState([]);
  const [countryOptions, setCountryOptions] = useState([]);
  const [organizationOptions, setOrganizationOptions] = useState([]);
  // const [templateOptions, setTemplateOptions] = useState([]);
  // const [loadingTemplateOptions, setLoadingTemplateOptions] = useState(false);
  const [provinceOptions, setProvinceOptions] = useState([]);
  const [schoolOptions, setSchoolOptions] = useState([]);
  const [gradeOptions, setGradeOptions] = useState([]);
  const [awardsOptions, setAwardsOptions] = useState([]);
  const [showOptions, setShowOptions] = useState([]);
  const [sortingOptions, setSortingOptions] = useState([]);
  const [indexNumberOptions, setIndexNumberOptions] = useState([]);
  const [studentNameOptions, setStudentNameOptions] = useState([]);
  const [csvFile, setCsvFile] = useState(null);
  const [csvIndexes, setCsvIndexes] = useState([]);
  const [csvValidationError, setCsvValidationError] = useState("");
  const [csvValidated, setCsvValidated] = useState(false);
  const [validIndexSet, setValidIndexSet] = useState(null);
  const [showCsvErrorModal, setShowCsvErrorModal] = useState(false);
  const csvInputRef = useRef(null);

  const getFilterData = async (param) => {
    const filterData = await getPrintCertificateFilter(param, {
      mode: mode,
      certificate_type: certificateType,
      competition: competition?.value,
      country: country?.value,
      // template: template?.value,
      school: Array.isArray(school)
        ? school.map((s) => s?.value).join(",")
        : school?.value,
      grade: Array.isArray(grade)
        ? grade.map((g) => g?.value).join(",")
        : grade?.value,
      organization: organization?.value,
      province: Array.isArray(province)
        ? province.map((p) => p?.value).join(",")
        : province?.value,
      participant_index: Array.isArray(indexNumber)
        ? indexNumber.map((i) => i?.value).join(",")
        : indexNumber?.value,
      participant_name: Array.isArray(studentName)
        ? studentName.map((s) => s?.value).join(",")
        : studentName?.value,
      award: awards.map((award) => award?.value).join(","),
      private_options: show?.value,
    });
    return filterData;
  };

  const handleChangeCertificateType = (event) => {
    const selectedValue = event.target.value;
    const option = certificateTypeOptions.find(
      (o) => String(o.value) === selectedValue
    );
    setCertificateType(option?.value ?? selectedValue);
    setCompetition("");
    setCompetitionOptions([]);
    !isPartnerOrAssistant() && !isTeacher() && setCountry("");
    setCsvFile(null);
    setCsvIndexes([]);
    setCsvValidationError("");
    setCsvValidated(false);
    !isPartnerOrAssistant() && !isTeacher() && setOrganization("");
    !isPartnerOrAssistant() && !isTeacher() && setProvince([]);
    setGrade([]);
    !isTeacher() && setSchool([]);
    setIndexNumber([]);
    setStudentName([]);
    setAwards([]);
    setShow("");
    setSelectedSortingOptions([]);
  };

  const handleChangeCompetition = (event, value) => {
    setCompetition(value);
    !isPartnerOrAssistant() && !isTeacher() && setCountry("");
    // setTemplate("");
    setCsvFile(null);
    setCsvIndexes([]);
    setCsvValidationError("");
    setCsvValidated(false);
    !isPartnerOrAssistant() && !isTeacher() && setOrganization("");
    !isPartnerOrAssistant() && !isTeacher() && setProvince([]);
    setGrade([]);
    !isTeacher() && setSchool([]);
    setIndexNumber([]);
    setStudentName([]);
    setAwards([]);
    setShow("");
    setSelectedSortingOptions([]);
  };

  const handleChangeCountry = (event, value) => {
    setCountry(value);
    // setTemplate("");
    setCsvFile(null);
    setCsvIndexes([]);
    setCsvValidationError("");
    setCsvValidated(false);
  };

  const handleChangeOrganization = (event, value) => {
    setOrganization(value);
  };

  const handleChangeProvince = (event, value) => {
    setProvince(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeSchool = (event, value) => {
    setSchool(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeGrade = (event, value) => {
    setGrade(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeAwards = (event, value) => {
    setAwards(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeShow = (event, value) => {
    setShow(value);
  };

  const handleChangeSort = (event, value) => {
    setSelectedSortingOptions(
      typeof value === "string" ? value.split(",") : value
    );
  };

  const handleChangeIndexNumber = (event, value) => {
    setIndexNumber(typeof value === "string" ? value.split(",") : value);
  };

  const handleChangeStudentName = (event, value) => {
    setStudentName(typeof value === "string" ? value.split(",") : value);
  };

  const parseCsvIndexes = (text) => {
    const lines = text.split(/\r?\n/).filter((line) => line.trim());
    if (lines.length === 0) return [];
    const header = lines[0].split(",").map((h) => h.trim().toUpperCase());
    const indexCol = header.findIndex(
      (h) =>
        h === "INDEX NUMBER" ||
        h === "INDEX" ||
        h === "INDEX_NUMBER" ||
        h === "STUDENT_INDEX" ||
        h === "PARTICIPANT_INDEX" ||
        h === "STUDENT INDEX" ||
        h === "PARTICIPANT INDEX"
    );
    const colIndex = indexCol >= 0 ? indexCol : 0;
    const indexes = [];
    for (let i = 1; i < lines.length; i++) {
      const cells = lines[i].split(",").map((c) => c.trim());
      const val = cells[colIndex];
      if (val) indexes.push(String(val));
    }
    return [...new Set(indexes)];
  };

  const handleCsvChange = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    setCsvFile(null);
    setCsvIndexes([]);
    setCsvValidationError("");
    setCsvValidated(false);
    if (!file) return;
    if (file.type !== "text/csv" && !file.name.toLowerCase().endsWith(".csv")) {
      setCsvValidationError("Please select a CSV file.");
      setShowCsvErrorModal(true);
      return;
    }
    const reader = new FileReader();
    reader.onload = async (ev) => {
      const text = ev.target?.result ?? "";
      const csvIndexes = parseCsvIndexes(text);
      setCsvFile(file);
      setCsvIndexes(csvIndexes);
      if (csvIndexes.length === 0) {
        setCsvValidationError(
          "No index numbers found in CSV (expect column 'student_index', 'participant_index', 'INDEX NUMBER' or first column)."
        );
        setShowCsvErrorModal(true);
        return;
      }
      if (!competition?.value || !country?.value) {
        setCsvValidationError(
          "Select competition and country first to validate indexes."
        );
        setShowCsvErrorModal(true);
        return;
      }
      try {
        const validOptions = await getFilterData("participant_index");
        const validOptionsList = Array.isArray(validOptions)
          ? validOptions
          : [];
        const validValues = new Set(
          validOptionsList.map((o) => String(o?.value ?? o?.label ?? o))
        );
        setValidIndexSet(validValues);
        const invalid = csvIndexes.filter(
          (idx) => !validValues.has(String(idx).trim())
        );
        if (invalid.length > 0) {
          const errMsg = `Some of the Participant indexes in CSV cannot be matched with indexes in DB: ${invalid
            .slice(0, 20)
            .join(", ")}${
            invalid.length > 20 ? ` (and ${invalid.length - 20} more)` : ""
          }.`;
          setCsvValidationError(errMsg);
          setShowCsvErrorModal(true);
          setCsvValidated(false);
        } else {
          const csvAsObjects = csvIndexes.map((idx) => {
            const strIdx = String(idx).trim();
            const match = validOptionsList.find(
              (o) => String(o?.value ?? o?.label ?? o) === strIdx
            );
            return match ?? { value: strIdx, label: strIdx };
          });
          const existing = Array.isArray(indexNumber) ? indexNumber : [];
          const existingValues = new Set(
            existing.map((i) => String(i?.value ?? i?.label ?? i))
          );
          const newFromCsv = csvAsObjects.filter(
            (obj) =>
              !existingValues.has(String(obj?.value ?? obj?.label ?? obj))
          );
          setIndexNumber([...existing, ...newFromCsv]);
          setCsvValidationError("");
          setCsvValidated(true);
        }
      } catch (err) {
        setCsvValidationError("Failed to validate indexes. Please try again.");
        setShowCsvErrorModal(true);
        setCsvValidated(false);
      }
    };
    reader.readAsText(file);
  };

  const clearCsv = () => {
    setCsvFile(null);
    setCsvIndexes([]);
    setCsvValidationError("");
    setCsvValidated(false);
    setValidIndexSet(null);
    setShowCsvErrorModal(false);
    if (csvInputRef.current) csvInputRef.current.value = "";
  };

  const downloadStudentIndexTemplate = () => {
    const headers = ["participant_index"];
    const emptyRows = Array.from({ length: 6 }, () => ",");
    const csvContent = [headers.join(","), ...emptyRows].join("\n");
    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "participant-index-template.csv");
    link.style.visibility = "hidden";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    const initializeModal = async () => {
      setLoading(true);
      const [modeData, certTypeData] = await Promise.all([
        getPrintCertificateFilter("mode", {}),
        getPrintCertificateFilter("certificate_type", {}),
      ]);
      const modes = mapFilterOptions(modeData);
      const certTypes = mapFilterOptions(certTypeData);
      setModeOptions(modes);
      setCertificateTypeOptions(certTypes);
      if (modes.length > 1) {
        setMode(modes[1].value);
      } else if (modes.length) {
        setMode(modes[0].value);
      }
      if (certTypes.length) {
        setCertificateType(certTypes[0].value);
      }

      // Prefill fields based on user role on modal open

      if (isPartnerOrAssistant()) {
        const countryIdAndName = {
          value: user.country.id,
          label: user.country.display_name,
        };
        setCountry(countryIdAndName);

        const orgIdAndName = {
          value: user.organization.id,
          label: user.organization.name,
        };
        setOrganization(orgIdAndName);
      }

      // For Teacher: Prefill country, organization, and school
      if (isTeacher()) {
        const countryIdAndName = {
          value: user.country.id,
          label: user.country.display_name,
        };
        setCountry(countryIdAndName);

        const orgIdAndName = {
          value: user.organization.id,
          label: user.organization.name,
        };
        setOrganization(orgIdAndName);

        const schoolIdAndName = {
          value: user.school.id,
          label: user.school.name,
        };
        setSchool([schoolIdAndName]);
      }
      setLoading(false);
    };

    initializeModal();
  }, []);

  if (loading) {
    return <LoadingBackdrop loading={loading} />;
  }

  return (
    <Box
      className="popUpModal"
      style={{
        width: 800,
        minHeight: 365,
        maxHeight: "90vh",
        padding: "0 20px",
        gap: "16px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "scroll",
      }}
    >
      <NunitoText
        value="PRINT NEW CERTIFICATE"
        fontSize={30}
        fontWeight={600}
        color="#5E75C3"
        marginTop={30}
        marginBottom={20}
      />
      <FormControl
        style={{
          width: 700,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {/* BACKGROUND OPTION */}
        <FormLabel
          id="demo-radio-buttons-group-label"
          style={{ fontSize: 18, marginRight: 20 }}
        >
          Mode:
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-radio-buttons-group-label"
          defaultValue={"with_background_template"}
          name="radio-buttons-group"
          row
          value={mode}
          onChange={(e) => setMode(e.target.value)}
        >
          {modeOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio checked={mode === option.value} />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>

      {/* PRINT WITH STATS - Only visible to admins */}
      {isAdmin() && (
        <FormControl
          style={{
            width: 700,
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={printWithStats}
                onChange={(e) => setPrintWithStats(e.target.checked)}
              />
            }
            label="Print with Stats:"
            labelPlacement="start"
            style={{
              marginLeft: 0,
            }}
          />
        </FormControl>
      )}

      <FormControl
        style={{
          width: 700,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {/* BACKGROUND OPTION */}
        <FormLabel
          id="certificate-type-radio-group-label"
          style={{ fontSize: 18, marginRight: 20 }}
        >
          Certificate Type:
        </FormLabel>
        <RadioGroup
          aria-labelledby="certificate-type-radio-group-label"
          name="certificate-type-radio-group"
          row
          value={certificateType != null ? String(certificateType) : ""}
          onChange={handleChangeCertificateType}
        >
          {certificateTypeOptions.map((option) => (
            <FormControlLabel
              key={option.value}
              value={String(option.value)}
              control={<Radio />}
              label={option.label}
            />
          ))}
        </RadioGroup>
      </FormControl>

      {/* COMPETITION */}
      <Autocomplete
        aria-required
        disablePortal
        onOpen={async () => {
          setLoadingCompetitionOptions(true);
          setCompetitionOptions([]);
          const compData = await getFilterData("competition");
          setCompetitionOptions(mapFilterOptions(compData));
          setLoadingCompetitionOptions(false);
        }}
        onChange={handleChangeCompetition}
        options={competitionOptions}
        sx={{ width: 700 }}
        noOptionsText={
          loadingCompetitionOptions ? (
            <Loader height={{ height: 32 }} />
          ) : (
            "No options"
          )
        }
        renderInput={(params) => (
          <TextField {...params} label="Competition" required />
        )}
        value={competition}
      />

      {/* COUNTRY */}
      <Autocomplete
        disablePortal
        onOpen={async () => {
          setLoadingCountryOptions(true);
          setCountryOptions([]);
          const countryData = await getFilterData("country");
          setCountryOptions(countryData);
          setLoadingCountryOptions(false);
        }}
        onChange={handleChangeCountry}
        options={countryOptions}
        sx={{ width: 700 }}
        noOptionsText={
          loadingCountryOptions ? (
            <Loader height={{ height: 32 }} />
          ) : (
            "No options"
          )
        }
        renderInput={(params) => (
          <TextField {...params} label="Country" required />
        )}
        value={country}
        disabled={!competition || isPartnerOrAssistant() || isTeacher()}
      />

      {/* CONFIGURATION (required) - Template field disabled for now
      <Autocomplete
        disablePortal
        onOpen={async () => {
          setLoadingTemplateOptions(true);
          setTemplateOptions([]);
          const templateData = await getFilterData("template");
          setTemplateOptions(Array.isArray(templateData) ? templateData : []);
          setLoadingTemplateOptions(false);
        }}
        onChange={(e, v) => {
          setTemplate(v);
          setCsvFile(null);
          setCsvIndexes([]);
          setCsvValidationError("");
          setCsvValidated(false);
        }}
        options={templateOptions}
        getOptionLabel={(opt) => opt?.label ?? ""}
        sx={{ width: 700 }}
        noOptionsText={
          loadingTemplateOptions ? (
            <Loader height={{ height: 32 }} />
          ) : (
            "No options"
          )
        }
        renderInput={(params) => (
          <TextField {...params} label="Template" required />
        )}
        value={template}
        disabled={
          !competition || !country || isPartnerOrAssistant() || isTeacher()
        }
      />
      */}

      {/* ORGANIZATION */}
      <Autocomplete
        disablePortal
        onOpen={async () => {
          setLoadingOrganizationOptions(true);
          setOrganizationOptions([]);
          const organizationData = await getFilterData("organization");
          setOrganizationOptions(organizationData);
          setLoadingOrganizationOptions(false);
        }}
        onChange={handleChangeOrganization}
        options={organizationOptions}
        sx={{ width: 700 }}
        noOptionsText={
          loadingOrganizationOptions ? (
            <Loader height={{ height: 32 }} />
          ) : (
            "No options"
          )
        }
        renderInput={(params) => <TextField {...params} label="Organization" />}
        value={organization}
        disabled={!competition || isPartnerOrAssistant() || isTeacher()}
      />

      {/* PROVINCE */}
      <Autocomplete
        multiple
        disablePortal
        onOpen={async () => {
          setLoadingProvinceOptions(true);
          setProvinceOptions([]);
          const provinceData = await getFilterData("province");
          setProvinceOptions(
            provinceData.filter(
              (retrievedProvince) =>
                !province.some((p) => p.value === retrievedProvince.value)
            )
          );
          setLoadingProvinceOptions(false);
        }}
        onChange={handleChangeProvince}
        options={provinceOptions}
        getOptionLabel={(option) => option.label}
        filterSelectedOptions={true}
        sx={{ width: 700 }}
        noOptionsText={
          loadingProvinceOptions ? (
            <Loader height={{ height: 32 }} />
          ) : (
            "No options"
          )
        }
        renderInput={(params) => <TextField {...params} label="Province" />}
        value={province}
        disabled={!competition || isPartnerOrAssistant() || isTeacher()}
      />

      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: 700,
        }}
      >
        {/* SCHOOL */}
        <Autocomplete
          multiple
          disablePortal
          onOpen={async () => {
            setLoadingSchoolOptions(true);
            setSchoolOptions([]);
            const schoolData = await getFilterData("school");
            setSchoolOptions(
              schoolData.filter(
                (retrievedSchool) =>
                  !school.some((s) => s.value === retrievedSchool.value)
              )
            );
            setLoadingSchoolOptions(false);
          }}
          onChange={handleChangeSchool}
          options={schoolOptions}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions={true}
          sx={{ width: 340 }}
          noOptionsText={
            loadingSchoolOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => <TextField {...params} label="School" />}
          value={school}
          disabled={!competition || isTeacher()}
        />

        {/* GRADE */}
        <Autocomplete
          multiple
          disablePortal
          onOpen={async () => {
            setLoadingGradeOptions(true);
            setGradeOptions([]);
            const gradeData = await getFilterData("grade");
            setGradeOptions(
              gradeData.filter(
                (retrievedGrade) =>
                  !grade.some((g) => g.value === retrievedGrade.value)
              )
            );
            setLoadingGradeOptions(false);
          }}
          onChange={handleChangeGrade}
          options={gradeOptions}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions={true}
          sx={{ width: 340 }}
          noOptionsText={
            loadingGradeOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => <TextField {...params} label="Grade" />}
          value={grade}
          disabled={!competition}
        />
      </Box>

      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: 700,
        }}
      >
        {/* AWARDS TO BE PRINTED */}
        <Autocomplete
          multiple
          id="tags-outlined"
          sx={{ width: 340 }}
          options={awardsOptions}
          getOptionLabel={(option) => option.label}
          onChange={handleChangeAwards}
          onOpen={async () => {
            setLoadingAwardsOptions(true);
            setAwardsOptions([]);
            const awardsData = await getFilterData("award");
            setAwardsOptions(
              awardsData.filter(
                (retrievedAward) =>
                  !awards.some((award) => award.value === retrievedAward.value)
              )
            );
            setLoadingAwardsOptions(false);
          }}
          filterSelectedOptions={true}
          noOptionsText={
            loadingAwardsOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => (
            <TextField {...params} label="Awards to be printed" />
          )}
          disabled={!competition}
        />

        {/* SHOW ALL/PRIVATE/NON-PRIVATE */}
        <Autocomplete
          disablePortal
          onOpen={async () => {
            setLoadingShowOptions(true);
            setShowOptions([]);
            const showData = await getFilterData("private_options");
            setShowOptions(showData);
            setLoadingShowOptions(false);
          }}
          onChange={handleChangeShow}
          options={showOptions}
          sx={{ width: 340 }}
          noOptionsText={
            loadingShowOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => (
            <TextField {...params} label="Show All/Private/Non-Private" />
          )}
          value={show}
          disabled={!competition}
        />
      </Box>

      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: 700,
        }}
      >
        {/* STUDENT INDEX NUMBER */}
        <Autocomplete
          multiple
          disablePortal
          isOptionEqualToValue={(option, value) =>
            (option?.value ?? option) === (value?.value ?? value)
          }
          onOpen={async () => {
            setLoadingIndexNumberOptions(true);
            setIndexNumberOptions([]);
            const indexNumberData = await getFilterData("participant_index");
            setIndexNumberOptions(
              indexNumberData.filter(
                (retrievedIndex) =>
                  !indexNumber.some(
                    (i) =>
                      (i?.value ?? i) ===
                      (retrievedIndex?.value ?? retrievedIndex)
                  )
              )
            );
            setLoadingIndexNumberOptions(false);
          }}
          onChange={handleChangeIndexNumber}
          options={indexNumberOptions}
          getOptionLabel={(option) =>
            option && typeof option === "object"
              ? option.label ?? String(option.value ?? "")
              : String(option ?? "")
          }
          filterSelectedOptions={true}
          limitTags={3}
          sx={{
            width: 240,
          }}
          // sx={{
          //   width: 240,
          //   "& .MuiOutlinedInput-root": {
          //     maxHeight: 200,
          //     overflowY: "scroll",
          //     flexWrap: "wrap",
          //     alignItems: "flex-start",
          //   },
          // }}
          // ListboxProps={{
          //   style: { maxHeight: 200, overflow: "auto" },
          // }}
          noOptionsText={
            loadingIndexNumberOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => (
            <TextField {...params} label="Student Index Number" />
          )}
          disabled={!competition || !country}
          value={indexNumber}
        />
        {/* STUDENT NAME */}
        <Autocomplete
          multiple
          disablePortal
          onOpen={async () => {
            setLoadingStudentNameOptions(true);
            setStudentNameOptions([]);
            const studentNameData = await getFilterData("participant_name");
            setStudentNameOptions(
              studentNameData.filter(
                (retrievedName) =>
                  !studentName.some((s) => s.value === retrievedName.value)
              )
            );
            setLoadingStudentNameOptions(false);
          }}
          onChange={handleChangeStudentName}
          options={studentNameOptions}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions={true}
          limitTags={3}
          sx={{
            width: 240,
          }}
          // sx={{
          //   width: 240,
          //   "& .MuiOutlinedInput-root": {
          //     maxHeight: 200,
          //     overflowY: "auto",
          //     flexWrap: "wrap",
          //     alignItems: "flex-start",
          //   },
          // }}
          // ListboxProps={{
          //   style: { maxHeight: 200, overflow: "auto" },
          // }}
          noOptionsText={
            loadingStudentNameOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => (
            <TextField {...params} label="Student Name" />
          )}
          disabled={!competition || !country}
          value={studentName}
        />
        {/* CSV with student indexes (optional) */}
        <Box>
          <input
            type="file"
            accept=".csv"
            ref={csvInputRef}
            style={{ display: "none" }}
            onChange={handleCsvChange}
            disabled={!competition || !country}
          />
          <Box
            display="flex"
            alignItems="center"
            gap={1}
            // flexWrap="wrap"
            flexDirection="row"
          >
            <ReusableButton
              text={<RiFileExcel2Fill size={30} color="white" />}
              bgColor={!competition || !country ? "#8D8D8D" : "green"}
              fontSize={14}
              height={50}
              onClick={() => csvInputRef.current?.click()}
              disabled={!competition || !country}
            />

            <ReusableButton
              text={"Template"}
              bgColor={"#5E75C3"}
              fontSize={14}
              height={50}
              onClick={downloadStudentIndexTemplate}
              disabled={!competition || !country}
              iconType="download"
            />

            {/* {csvFile && (
              <ReusableButton
                text="Clear CSV"
                bgColor="#E83042"
                fontSize={14}
                height={40}
                onClick={clearCsv}
              />
            )} */}
          </Box>

          <Modal
            open={showCsvErrorModal && !!csvValidationError}
            onClose={() => setShowCsvErrorModal(false)}
          >
            <Box
              component="div"
              sx={{
                outline: "none",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: 500,
                bgcolor: "background.paper",
                boxShadow: 24,
                p: 3,
                borderRadius: 2,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <NunitoText
                value="CSV Validation Error"
                fontSize={24}
                fontWeight={600}
                color="#E83042"
                marginBottom={2}
              />
              <Box sx={{ fontSize: 15, color: "#333", mb: 3 }}>
                {csvValidationError}
              </Box>
              <ReusableButton
                text="OK"
                bgColor="#5E75C3"
                fontSize={18}
                height={48}
                width={120}
                onClick={() => setShowCsvErrorModal(false)}
              />
            </Box>
          </Modal>
          {/* {csvFile && csvValidated && !csvValidationError && (
            <Box sx={{ color: "green", fontSize: 13, mt: 1 }}>
              {csvIndexes.length} index(es) validated. They will be used for
              printing.
            </Box>
          )} */}
        </Box>
      </Box>
      <Box
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          width: 700,
        }}
      >
        {/* SORTING OPTIONS */}
        <Autocomplete
          multiple
          id="tags-outlined"
          onOpen={async () => {
            setLoadingSortingOptions(true);
            setSortingOptions([]);
            const allSortingOptions = await getFilterData("sorting_options");
            setSortingOptions(
              allSortingOptions.filter(
                (sortingOption) =>
                  !selectedSortingOptions.some(
                    (selectedSortingOption) =>
                      selectedSortingOption.groupValue ===
                      sortingOption.groupValue
                  )
              )
            );
            setLoadingSortingOptions(false);
          }}
          onChange={handleChangeSort}
          options={sortingOptions}
          groupBy={(option) => option.groupLabel}
          getOptionLabel={(option) => option.label}
          filterSelectedOptions={true}
          sx={{ width: 340 }}
          noOptionsText={
            loadingSortingOptions ? (
              <Loader height={{ height: 32 }} />
            ) : (
              "No options"
            )
          }
          renderInput={(params) => <TextField {...params} label="Sort by" />}
          disabled={!competition}
          value={selectedSortingOptions}
        />
      </Box>

      <Grid
        container
        justifyContent="space-evenly"
        style={{ marginBlock: "30px 20px" }}
      >
        <ReusableButton
          text="Cancel"
          bgColor="#8D8D8D"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => cancelApprove()}
        />
        <ReusableButton
          text="Confirm"
          bgColor="#5E75C3"
          fontSize={25}
          height={63}
          width={280}
          onClick={() => {
            if (!(competition && country)) {
              alert("Please select a competition and country");
            } else if (certificateType == null || certificateType === "") {
              alert("Please select a certificate type");
            } else {
              const includeStats = isAdmin() ? printWithStats : true;
              approveFunction({
                mode,
                certificateType,
                competition,
                country,
                // template,
                organization,
                province,
                school,
                grade,
                indexNumber,
                studentName,
                awards,
                show,
                selectedSortingOptions,
                includeStats,
              });
            }
          }}
        />
      </Grid>
    </Box>
  );
}
